import React from "react";
import { UscLabel } from "../../../utils/labels";
import { useUscSelector } from "../../../redux/store";
import { isRetailerPage } from "../../../../shared-logic/utils/uscUtils";
import Button from "../../../../shared-components/toyota/styles/atoms/Button";
import Icon from "../../../../shared-components/toyota/styles/atoms/Icon";
import List from "../styles/atoms/List";
import { trackAemContactDealerCtas } from "../../../utils/tracking";
import type { DealerInfoType } from "../../../utils/constants";
import { getDealerContactInfoList } from "../../../utils/helpers";
import * as Styles from "./DealerContactInfo.styles";

type PropsType = {
    isPdf?: boolean;
};

const WEBSITE_MAX_CHAR_LENGTH = 30; // basket ~34, pdp ~38 -> 30 to be safe

const DealerContactInfo = (props: PropsType): JSX.Element | null => {
    const { isPdf } = props;
    const dealer = useUscSelector((state) => state.dealer.dealer);
    const settings = useUscSelector((state) => state.uscSettings);
    const commonSettings = useUscSelector((state) => state.commonSettings);
    const vehicleType = useUscSelector((state) => state.vehicle.type);

    const list = dealer ? getDealerContactInfoList(dealer, settings, commonSettings) : [];

    // do not return anything when no lines will be rendered
    if (!dealer || list.length < 1) return null;

    const trackClick = (type: DealerInfoType): void => {
        trackAemContactDealerCtas(type, dealer, vehicleType);
    };

    return (
        // data-cpdqm="ignore" => Ignore DQM test for the buttons: 2.4 - Indicate when a link will open in a new window/tab
        <List variant="unstyled" dataCpdqm="ignore">
            {list
                // We filter out the retailer page as it gets shown in PDPDealer.
                .filter((item) => !isRetailerPage(item, dealer.id))
                .map((item) => (
                    <Styles.ListItem key={item.text}>
                        <Button
                            variant="icon-text"
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => trackClick(item.type)}
                        >
                            {item.type === "website" && item.text.length > WEBSITE_MAX_CHAR_LENGTH && !isPdf ? (
                                <UscLabel label="uscPdpDealerContactLinkTitle" />
                            ) : (
                                item.text
                            )}
                            <Icon variant="external-link" />
                        </Button>
                    </Styles.ListItem>
                ))}
        </List>
    );
};

export default DealerContactInfo;
